/**
 * Stores a non-sensitive hint in localStorage indicating the user previously had an active session.
 *
 * This is intentionally NOT a security mechanism — it contains no tokens or user data.
 * Its sole purpose is to distinguish "first visit" from "session expired" so the UI
 * can avoid showing a misleading "session expired" banner to new users.
 *
 * The hint is set on successful authentication and cleared on explicit logout.
 * If the user clears localStorage manually, the worst outcome is no session-expired banner
 * on the next failed recovery attempt — which is acceptable.
 */

const SESSION_HINT_KEY = 'app:has_session';
const SESSION_HINT_VALUE = 'USER_ALREADY_HAD_SESSION';

export const sessionHintService = {
  set(): void {
    try {
      localStorage.setItem(SESSION_HINT_KEY, SESSION_HINT_VALUE);
    } catch {
      // localStorage unavailable (private browsing quota exceeded, etc.) — fail silently
    }
  },

  clear(): void {
    try {
      localStorage.removeItem(SESSION_HINT_KEY);
    } catch {
      // fail silently
    }
  },

  exists(): boolean {
    try {
      return localStorage.getItem(SESSION_HINT_KEY) === SESSION_HINT_VALUE;
    } catch {
      return false;
    }
  },
};
